const default_data = []

function reducer( state = default_data, { type, payload } ){
    switch( type ){
        case 'agregarDireccion': {
            const i = state.findIndex( item => item.formated_address === payload.formated_address )
            if(i < 0 ) return [ ...state, ...[payload] ]
            return state
        }
        case "actualizarDireccion": {
            const i = state.findIndex( item => item.formated_address === payload.formated_address )
            console.log({i,state})
            if(i < 0 ) return state
            state[i] = payload
            return [ ...state ]
        }
        case "removeAddress": {
            return [ ...state ].filter( item => item.formated_address !== payload.formated_address )
        }
        default:
            return state
    }
}

export default reducer